<template>
  <section class="game-app" :class="[{ 'download-hover': isDownloadHovered }]">
    <div class="container game-app-container">
      <img :src="iconAirtime" alt="Icone Airtime" class="airtime-icon-pixel" />

      <div class="game-app-right">
        <img :src="airtimeLogo" alt="Airtime" class="airtime-logo-pixel" />
        <a
          href="https://play.google.com/store/apps/details?id=com.gusmachado.airtime"
          target="_blank"
          rel="noopener noreferrer"
          class="download-link"
          @mouseenter="isDownloadHovered = true"
          @mouseleave="isDownloadHovered = false"
          @focus="isDownloadHovered = true"
          @blur="isDownloadHovered = false"
        >
          <img :src="downloadBadge" alt="Download" class="download-badge" />
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import iconAirtime from '@/assets/games/iconAirtime.png'
import airtimeLogo from '@/assets/games/airtime.png'
import gpDownloadPTBR from '@/assets/games/gp_downloadPTBR.svg'
import gpDownloadENUS from '@/assets/games/gp_downloadENUS.svg'

const { locale } = useI18n()
const isDownloadHovered = ref(false)

const downloadBadge = computed(() =>
  locale.value === 'pt' ? gpDownloadPTBR : gpDownloadENUS
)
</script>

<style scoped>
.game-app {
  min-height: 0;
  background: var(--color-light);
  color: var(--color-bg-dark);
  transition: background-color 0.45s ease, border-top-color 0.45s ease;
  border-top: 30px solid var(--color-light);
}

.game-app.download-hover {
  background: #4a90e2;
  border-top-color: #4a90e2;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px;
}

.game-app-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding-top: 0;
}

.airtime-icon-pixel {
  height: 200px;
  width: auto;
  image-rendering: pixelated;
  image-rendering: crisp-edges;
  border-radius: 15%;
}

.game-app-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.airtime-logo-pixel {
  width: 320px;
  height: auto;
  image-rendering: pixelated;
  image-rendering: crisp-edges;
}

.game-app:hover .airtime-logo-pixel,
.game-app:focus-within .airtime-logo-pixel {
  animation: airtime-bob 1.2s ease-in-out infinite;
}

.download-link {
  display: inline-flex;
}

.download-badge {
  width: 220px;
  height: auto;
}

@keyframes airtime-bob {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5%);
  }
}

@media (aspect-ratio <= 3/4) {
  .container {
    max-width: none;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  .game-app-container {
    flex-direction: column;
    align-items: center;
  }

  .airtime-icon-pixel {
    height: 150px;
  }

  .airtime-logo-pixel {
    width: 260px;
  }
}
</style>
